import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createCompetition } from "../../../../services/competition";
import { useState } from "react";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { ColorSelector } from "../../../general/color-selector";

interface AdminCompetitionNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminCompetitionNew(props: AdminCompetitionNewProps) {
    const [media, setMedia] = useState<Media[]>([]);
    const [color, setColor] = useState('#34B689');

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            description: event.target.description.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value,
            date_description: event.target.date_description.value,
            venue_name: event.target.venue_name.value,
            venue_link: event.target.venue_link.value,
            documents: media.map((m: Media) => { return m.id; }),
            color: color
        }
        createCompetition(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        const newMedia = media.map((m: Media) => { return m; });
        setMedia(newMedia);
    }

    const handleSetColor = (color: string) => {
        setColor(color);
    }

    return (
        <Modal className="admin-competition-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_competition") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                        <div className="dates">
                            <Form.Group className="mb-3 date-start" controlId="date_start">
                                <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                                <Form.Control type="date" name="date_start" required />
                            </Form.Group>
                            <Form.Group className="mb-3 date-end" controlId="date_end">
                                <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                                <Form.Control type="date" name="date_end" required />
                            </Form.Group>
                        </div>
                        <Form.Group className="mb-3" controlId="date_description">
                            <Form.Label>{ t("date_description") }</Form.Label>
                            <Form.Control type="text" name="date_description" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="venue_name">
                            <Form.Label>{ t("venue_name") }</Form.Label>
                            <Form.Control type="text" name="venue_name" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="venue_link">
                            <Form.Label>{ t("venue_link") }</Form.Label>
                            <Form.Control type="text" name="venue_link" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="color">
                            <Form.Label>{ t("color") }</Form.Label>
                            <ColorSelector setColor={ handleSetColor } defaultColor={ color } />
                        </Form.Group>
                        <Form.Group className="mb-3 media-field" controlId="media">
                            <Uploader title={ t("documents_upload_message") }
                                media={ media } save={ handleMediaEventUpload } />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}